import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { LppClaimsComponent } from './lpp-claims/lpp-claims.component';
import { LppCancellationComponent } from './lpp-cancellation/lpp-cancellation.component';
import { InsuranceRemitComponent } from './insurance-remit/insurance-remit.component';

@Component({
	selector: 'app-lpp-reports',
	templateUrl: './lpp-reports.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./lpp-reports.component.scss'],
	imports: [
		MatTabGroup,
		MatTab,
		LppClaimsComponent,
		LppCancellationComponent,
		InsuranceRemitComponent,
	],
})
export class LppReportsComponent {}
